export default __webpack_public_path__ + "static/media/bar_chart-default.1b96caa1.svg";